import { ref, onMounted, watch } from 'vue';

import { formatSec, logintest } from '@/lib/common';
import { getRankings } from '@/lib/rankings';

import { config } from '@/config';
import { User } from '@/@types/d';

export const TopRankingComponentSetup = () => {
  let currentUser = ref({} as User);
  let loggedIn = ref(false); 

  const courses = ref([]);
  const rankings = ref();
  
  const tabList = [
    {label: '最近の視聴数', type: 'show-recent'},
    {label: '評価数', type: 'like-all'},
  ];
  let selectedTab = ref(0);

  onMounted(() => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });

  const initView = async () => {
    // rankings.value = await getRankings(currentUser.value.company);
    getRankings(currentUser.value.company||'', rankings);
    changeTab(selectedTab.value);
  };
  const clearView = () => {
    courses.value = [];
  };

  watch(rankings, () => {
    changeTab(selectedTab.value);
  })

  const listCourses = () => {
    if(!courses.value) return [];
    const r = courses.value
      .filter((v:any) => v.course)
      .map((v:any) => v.course);
    return r.slice(0, config.RANKING_DIGEST_LIMIT);
  };
  
  const changeTab = (i:number) => {
    selectedTab.value = i;
    // initView();
    //@ts-ignore
    if(rankings.value) courses.value = rankings.value[tabList[i].type];
  };

  return {
    listCourses,
    formatSec,
    tabList,
    selectedTab,
    changeTab,
  };
};
